import axios from "axios";
import { buildApiUrl } from "../config/api";

export async function fetchTeacherCurrentTermResources(teacherId, { resourceType } = {}) {
    const params = new URLSearchParams();
    if (resourceType) params.set("resourceType", resourceType);
    const qs = params.toString();
    const { data } = await axios.get(
        buildApiUrl(`/TermResources/teacher/${teacherId}/current${qs ? `?${qs}` : ""}`)
    );
    return data;
}

export async function fetchClassCurrentTermResources(classId, { subjectId, resourceType } = {}) {
    const params = new URLSearchParams();
    if (subjectId) params.set("subjectId", subjectId);
    if (resourceType) params.set("resourceType", resourceType);
    const qs = params.toString();
    const { data } = await axios.get(
        buildApiUrl(`/TermResources/class/${classId}/current${qs ? `?${qs}` : ""}`)
    );
    return data;
}

export async function fetchSchoolResourceOverview(schoolId) {
    const { data } = await axios.get(buildApiUrl(`/TermResources/school/${schoolId}/overview`));
    return data;
}

export async function recordResourceDownload(resourceId) {
    const { data } = await axios.post(buildApiUrl(`/TermResources/${resourceId}/download`));
    return data;
}

export async function updateTeachingResourceMeta(resourceId, payload) {
    const { data } = await axios.put(buildApiUrl(`/TermResources/${resourceId}`), payload);
    return data;
}
